import React, { useEffect, useState } from 'react';
import { Marker } from '@react-google-maps/api';
import { resolveCustomMarkerIconUrl } from '../global/GlobalUtils';
import {
    CUSTOM_MARKER_FALLBACK_ICON_URL,
    googleZoomMeetsCustomMarkerVisibility,
} from './customMarkerConfig';
import {
    getCustomMarkerIconAnchor,
    getCustomMarkerIconSizePx,
} from './customMarkerZoom';

const CustomMarker = ({
    position,
    iconUrl,
    description,
    googleZoom,
    frontStyleLvz,
}) => {
    const [resolvedIconUrl, setResolvedIconUrl] = useState(null);

    useEffect(() => {
        const primary = resolveCustomMarkerIconUrl(iconUrl);
        if (!primary) {
            setResolvedIconUrl(CUSTOM_MARKER_FALLBACK_ICON_URL);
            return;
        }

        setResolvedIconUrl(primary);
        const img = new Image();
        img.onerror = () => {
            setResolvedIconUrl(CUSTOM_MARKER_FALLBACK_ICON_URL);
        };
        img.src = primary;
    }, [iconUrl]);

    if (
        !position ||
        !iconUrl ||
        !googleZoomMeetsCustomMarkerVisibility(googleZoom, description)
    ) {
        return null;
    }

    if (!resolvedIconUrl || !window.google?.maps) {
        return null;
    }

    const size = getCustomMarkerIconSizePx(frontStyleLvz);
    const anchor = getCustomMarkerIconAnchor(size);

    const customIcon = {
        url: resolvedIconUrl,
        scaledSize: new window.google.maps.Size(size, size),
        anchor: new window.google.maps.Point(anchor.x, anchor.y),
    };

    return (
        <Marker
            position={position}
            icon={customIcon}
            title={description || undefined}
        />
    );
};

export default CustomMarker;
